export default __webpack_public_path__ + "static/sc-gov-30b0a0a6a13159b650fe7affb7fac31f.webp";